<template>
  
  <div>
    <div v-if="cshowPopup" class="cookies-popup">
      <div class="cookies-popup-content">
        <p class="p">This website uses cookies to ensure you get the best experience on our website.</p>
        <div class="cookies-flex">
          <button class="cookies-btn-cancel" style="margin-right: 5px" @click="acceptCookies">Accept</button>
          <button class="cookies-btn" @click="cancelCookies">Cancel</button>


        </div>
      </div>

  </div>
  <FormModal v-if="showPopup" :closePopup="closePopup" />
    <Navbar :openPopup="openPopup"/>
    <MainBanner :openPopup="openPopup"/>
    <Funfacts />
  

    <IncludedBestFeatures />
     <Features />
     <MobileAppServices />
      <AppScreens />
     <ApiAi/>
       <Screenshots />
 <CustomAi/>
 <MarketingService/>
 <CrmWeb/>
    <BestFeaturesEver />
    <IndustryWeServe/>
    <!-- <Feedback /> -->
    <Partner />
   
    <ChallengesAndTrack />
    <SoftwareIntegrations />
  
    <!-- <Team /> -->
    <ServiceTeam :data="techData"/>
    <Blog />
    <!-- <CustomerReviews /> -->
    <AppReviews/>
    <Stats />

    <!--  <Video />
        <GettingBestApp />
        <AppDownload />
        <Pricing />
        <FreeTrial />
        <Footer /> -->
        <FooterStyleFour />
  </div>
</template>
<style>
.cookies-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #000000c9;
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 11;
}

.cookies-popup-content {
     margin: 0 auto;
    display: flex;
    padding: 0px 20px;
    align-items: center;
    justify-content: center;
    gap: 20px;
}
.p {
  color:#fff
}
.cookies-flex { 
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
button.cookies-btn-cancel {
    background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
    color: #fff;
    padding: 7px 15px;
    border-radius: 5px;
    cursor: pointer;
    border: none;
}

button.cookies-btn {
    padding: 7px 15px;
    border-radius: 5px;
    background-color: #eee;
    color: #000;
    cursor: pointer;
    border: none;
}
.cookies-popup-content p {
    line-height: 22px;
    margin-bottom: 0px;
}

@media screen and (max-width: 767px) {
  .cookies-popup-content { 
        padding: 0px 0px;
        flex-direction: column;
            gap: 10px;
  }
  .cookies-popup {
    padding: 6px 0px 12px;
}
  .cookies-popup-content p {
    text-align: center;
    padding: 0 40px;
}
}
</style>
<script>
import Navbar from "../Layout/Navbar";
import Funfacts from "../AboutOne/Funfacts.vue";
import IncludedBestFeatures from "../HomeOne/IncludedBestFeatures";
import Feedback from "../AboutTwo/Feedback";
import BestFeaturesEver from "../FeaturesOne/BestFeaturesEver";
import Partner from "../Common/Partner.vue";
import AppScreens from "../HomeOne/AppScreens";
import ChallengesAndTrack from "../AboutOne/ChallengesAndTrack";
// import SoftwareIntegrations from '../Common/SoftwareIntegrations'
import SoftwareIntegrations from "../AboutOne/SoftwareIntegrations";
import Screenshots from "../HomeSix/Screenshots";
 
import Blog from "../BlogOne/Blog";
 
import Stats from '../AboutOne/Stats.vue'

import MainBanner from "../HomeOne/MainBanner";
import Features from "../HomeOne/Features";
 
// import CustomerReviews from '../Common/CustomerReviews'
 
 import FooterStyleFour from '../Layout/FooterStyleFour'
// import ServiceTeam from "./Services/ServiceTeam";
import axios from "axios";
import AppReviews from "./AppReviews.vue";
import FormModal from "../HomeThree/FormModal.vue";
import ServiceTeam from "./Homepage/ServiceTeam.vue";
import IndustryWeServe from "../HomeOne/IndustryWeServe.vue";
import { injectSchemaMarkup, generateHomePageSchema } from "../../utils/schemaUtils";
import MobileAppServices from "../HomeOne/MobileAppServices.vue";
import ApiAi from "../HomeOne/ApiAi.vue";
import CustomAi from "../HomeOne/CustomAi.vue";
import MarketingService from "../HomeOne/MarketingService.vue";
import CrmWeb from "../HomeOne/CrmWeb.vue";



export default {
  name: "HomePageOne",
  components: {
    Navbar,
    Funfacts,
    MainBanner,
    Features,
    Feedback,
    BestFeaturesEver,
    Partner,
    MobileAppServices,
    ApiAi,
    CustomAi,
    MarketingService,
    CrmWeb,
    AppScreens,
    Screenshots,
    Blog,
    Stats,
    IncludedBestFeatures,
    ChallengesAndTrack,
    SoftwareIntegrations,
    FooterStyleFour,
    ServiceTeam,
    AppReviews,
    FormModal,
    IndustryWeServe
},
data() {
    return {
      baseUrl: 'https://content.meander.software',
    
      techData:[],
      isLoading: false,
      showPopup: false,
      cshowPopup:true

    }
  },
async mounted() {
    await this.getData2();
    
    // Inject schema markup for SEO
    try {
      const schemas = generateHomePageSchema();
      injectSchemaMarkup(schemas);
    } catch (error) {
      console.error('Error injecting schema markup:', error);
    }
  },
  methods: {
      openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    cancelCookies() {
      this.cshowPopup = false;
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.cshowPopup = false;
    },
    async getData2() {
      try {
        const response = await axios.get(`${this.$baseUrl}/ms-services?populate=ms_services_technologies_experts.image,ms_services_client_technologies.technologies`);
        const { data } = response
        this.techData = data.data;
        // Set comprehensive SEO meta tags for homepage
        document.title = "Best Software Company in US & India | Meander Software";
        
        // Helper to set or update a meta tag
        function setMeta(name, content, attr = 'name') {
          let element = document.querySelector(`meta[${attr}="${name}"]`);
          if (!element) {
            element = document.createElement('meta');
            element.setAttribute(attr, name);
            document.head.appendChild(element);
          }
          element.setAttribute('content', content || '');
        }

        // Set basic meta tags
        setMeta('title', 'Best Software Company in US & India | Meander Software');
        setMeta('description', 'Meander Software is a leading software development company providing professional app and website development services. We specialize in creating innovative and customized solutions to help businesses thrive in the digital world.');
        setMeta('keywords', 'software development company, app development, website development, custom software, software solutions, digital transformation, meander software');

        // Open Graph tags
        setMeta('og:title', 'Best Software Company in US & India | Meander Software', 'property');
        setMeta('og:description', 'Meander Software is a leading software development company providing professional app and website development services. We specialize in creating innovative and customized solutions.', 'property');
        setMeta('og:type', 'website', 'property');
        setMeta('og:url', window.location.href, 'property');
        setMeta('og:image', 'https://meander.software/og-default-image.jpg', 'property');
        setMeta('og:image:width', '1200', 'property');
        setMeta('og:image:height', '630', 'property');
        setMeta('og:image:alt', 'Best Software Company in US & India | Meander Software', 'property');

        // Twitter Card tags
        setMeta('twitter:title', 'Best Software Company in US & India | Meander Software', 'name');
        setMeta('twitter:description', 'Meander Software is a leading software development company providing professional app and website development services. We specialize in creating innovative and customized solutions.', 'name');
        setMeta('twitter:image', 'https://meander.software/og-default-image.jpg', 'name');
        setMeta('twitter:image:alt', 'Best Software Company in US & India | Meander Software', 'name');
        setMeta('twitter:card', 'summary_large_image', 'name');
        setMeta('twitter:site', '@meandersoftware', 'name');
        setMeta('twitter:creator', '@meandersoftware', 'name');

        // Update canonical URL
        let canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) {
          canonical.setAttribute('href', window.location.href);
        } else {
          canonical = document.createElement('link');
          canonical.setAttribute('rel', 'canonical');
          canonical.setAttribute('href', window.location.href);
          document.head.appendChild(canonical);
        }

      } catch (error) {
        console.error(error);
      }
    },
    async handleNavbarLinkClick(event) {
      this.isLoading = true
      if (event?.target?.href?.includes('services')) {
        await this.getData();
      }
      
      this.isLoading = false
    },
  },
  created() {
    if (localStorage.getItem('cookiesAccepted') === 'true') {
      this.cshowPopup = false;
    }
  },
};
</script>
